import { ChangeDetectorRef, Component } from '@angular/core';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/inspection.model';

@Component({
    templateUrl: './job-produced.component.html',
    standalone: false
})
export class InstallationJobProducedPluginComponent {
  public jobProduced: any;
  public config: any;
  public editRoute = ['installation', 'jobproduced', 'edit'];

  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    this.jobProduced = this.config.JobProduced;
  }
}
PluginComponent.plugins['installationjobproduced'] = InstallationJobProducedPluginComponent;
